export default __webpack_public_path__ + "static/media/noia.61c987a7.gif";